import React, { useEffect, useState } from "react";
import { sendToExternal } from "./lib/data";
import * as notify from "../../shared/notify";
import TaskStatus from "../../components/task-status";
import { getTasksByContextKey } from "../../components/task-list/lib/taskData";
import RepostOptions from "./repost-options";
import { DESTINATION_OPTIONS } from "./repost-options";
import { SourcePage } from "shared/taskTypeMap";

const RepostModal = ({ closeModal, taskContextKey, isExternalRepost, disableWithUpdate, disableWithoutUpdate, isSalesSample }) => {
    const [state, setState] = useState({
        isLoaded: false,
        tasks: [],
        upc: "",
        binNumber: "",
        disableList: [],
    });
    const [repostData, setRepostData] = useState(null);
    const [disableResubmit, setDisableResubmit] = useState(false);

    useEffect(() => {
        buildTaskData();
    }, []);

    const buildTaskData = async () => {
        const tasks = await getTasksByContextKey(taskContextKey);
        const fullUpc = tasks[0].context.productModifier ? `${tasks[0].context.upc}-${tasks[0].context.productModifier}` : tasks[0].context.upc;
        const binNumber = tasks[0].context.binTrackingNumber;

        const disable = DESTINATION_OPTIONS.reduce((dis, opt) => {
            const hasAttribute = !!tasks[0].context[opt.expectedAttribute];

            if (!hasAttribute) {
                dis.push(opt.value);
            }

            return dis;
        }, []);

        setState({
            isLoaded: true,
            tasks,
            upc: fullUpc,
            binNumber,
            disableList: disable,
        });
    };

    const onCancel = () => {
        closeModal();
    };

    const updateRepostData = (data) => {
        setRepostData(data);
    };

    const handleRepost = () => {
        const { destination, shouldUpdatePostDate, sendToGdsn } = repostData;

        if (!destination || destination.length === 0) {
            notify.error("At least one destination is required");

            return false;
        }

        const response = sendToExternal([taskContextKey], destination, shouldUpdatePostDate, sendToGdsn);

        if (!response) {
            return false;
        }

        notify.success("Product resubmitted successfully");
        closeModal();
    };

    const bin = state.binNumber ? (
        <span
            className="memo"
            style={{ float: "right" }}
        >
            Bin#: {state.binNumber}
        </span>
    ) : null;

    const selectedTask = state.tasks.find(({ context }) => context.upc === state.upc);

    return (
        <div>
            <h1>
                {state.upc} {bin}
            </h1>
            {!isExternalRepost && (
                <>
                    <TaskStatus
                        contextKey={taskContextKey}
                        tasks={state.tasks}
                        refreshTaskList={buildTaskData}
                        isFinalized={false}
                        sourcePage={SourcePage["finalqa.standard"]}
                        isSalesSample={isSalesSample}
                    />
                    <div className="button-group -right">
                        <button
                            className="button"
                            onClick={onCancel}
                        >
                            Close
                        </button>
                    </div>
                </>
            )}
            {isExternalRepost && (
                <div className="external-repost-form">
                    <RepostOptions
                        disable={state.disableList}
                        updateData={updateRepostData}
                        selectedTask={selectedTask}
                        disableWithUpdate={disableWithUpdate}
                        disableWithoutUpdate={disableWithoutUpdate}
                        setDisableResubmit={setDisableResubmit}
                    />
                    <div className="row">
                        <div className="button-group">
                            <button
                                className="button -left"
                                onClick={onCancel}
                            >
                                Cancel
                            </button>
                        </div>
                        <div className="button-group -right">
                            <button
                                className="button -primary"
                                onClick={handleRepost}
                                disabled={disableResubmit}
                            >
                                Repost
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RepostModal;
